export let toRefiner_SearchPlaceholder = "cUF6E";
export let toRefiner_RemovePerson = "MCkbJ";
export let toRefiner_ClearSearch = "iu9okc";
export let toRefiner_Suggestions = "SvtAqe";
export let toRefiner_Loading = "Jwa6G";
export let toRefiner_NoSuggestions = "VFa4ed";
export let toRefiner_SelectedPerson = "Z7TCXd";
export let toRefiner_SelectedCount = "NKZuce";
export default {toRefiner_SearchPlaceholder,toRefiner_RemovePerson,toRefiner_ClearSearch,toRefiner_Suggestions,toRefiner_Loading,toRefiner_NoSuggestions,toRefiner_SelectedPerson,toRefiner_SelectedCount};